/*
  ck toolTips
  Module for tooltips interactivity
  note: tooltips added by cms are handled by jquery.ckpromos.neo.js
 */
$(function () {

  /*TOOL TIPS FOR ALT PRINTINGS*/
  $(document).on({
    mouseenter: function () {
      if ( $(this).find('.ckTooltipPrinting').length < 1) {
        var _title =  $(this).find('a').data('title');
        var $html = $("<div>", {class: "ckTooltipPrinting"}).text(_title);
        $(this).append($html);
      }
    },
    mouseleave: function () {
      $(this).find('.ckTooltipPrinting').remove();
    }
  }, '#printings > li:not(.showAllVersions)');

});
